import { isValidPhoneNumber } from 'react-phone-number-input';

export const NAME_REGEX = /^[a-zA-Z][a-zA-Z\s'.\-]{2,59}$/;

export const validateFullName = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return 'Name is required.';
  if (trimmed.length < 3) return 'Name must be at least 3 characters.';
  if (trimmed.length > 60) return 'Name must be under 60 characters.';
  if (!NAME_REGEX.test(trimmed)) return "Only letters, spaces, hyphens, apostrophes and dots are allowed.";
  return '';
};

export const validatePhone = (value) => {
  if (!value) return 'Phone number is required.';
  if (!isValidPhoneNumber(value)) return 'Please enter a valid phone number.';
  return '';
};